// extracted by mini-css-extract-plugin
export default {"icon":"Head_icon__Q3Xmq","header":"Head_header__VGgfT"};